import styled from 'styled-components';

import { breakpoints, ReactFCC, theme } from '@notino/react-styleguide';

export const ActionCardWrapper = styled.div<{ isUnderSelectBox?: boolean }>`
  position: relative;
  padding: 0.75rem;
  border-radius: 2px;

  background-color: ${theme.color.common.magenta95};

  margin: ${(props) =>
    props.isUnderSelectBox ? '0 0 0.75rem 0' : '0.75rem 0 0.75rem 0'};

  @media (min-width: ${breakpoints.md}) {
    margin: 1rem 0 0.75rem 0;
  }

  &::after {
    content: ' ';
    height: 1rem;
    width: 1rem;
    background-color: ${theme.color.common.magenta95};
    border-radius: 2px;
    position: absolute;
    top: -5px;
    right: 1.3rem;
    transform: rotate(45deg);
  }
`;

export const ActionCardInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2px;
`;

export const PictogramRegularPercentageDiscountWrapper = styled.div`
  margin: 0 0 0 2rem;

  @media (min-width: ${breakpoints.sm}) {
    margin: 0 0 0 1rem;
  }

  @media (min-width: ${breakpoints.md}) {
    margin: 0 0 0 2.5rem;
  }

  z-index: 1;
  > div {
    font-size: 0.9rem;
    font-weight: 500;
    width: 3rem;
    height: 3rem;
    > span {
      margin: 0;
    }
  }
`;

export const PriceDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ActionPriceDescription = styled.div`
  ${theme.typography.labelSmall400}
`;

export const CurrencyWrapper = styled.span<{
  isSpaced: boolean;
  isPrefix: boolean;
}>`
  &:before {
    content: ${(props) => (props.isSpaced && !props.isPrefix ? '" "' : '')};
  }
  &:after {
    content: ${(props) => (props.isSpaced && props.isPrefix ? '" "' : '')};
  }
` as ReactFCC;

export const Slash = styled.span`
  padding: 0 0.25rem;
`;

export const DiscountAmountWrapper = styled.span`
  color: ${theme.color.text.highlight};

  ${theme.typography.titleMedium}
`;
